// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings_body__gT4Kj {
  background-color: #F3F2F0;
  margin: 0;
  /* padding: 0; */
}

.settings_darkthemebody__YlAZc {
  background-color: #363537;
}

/* *{
    margin: 0 !important;
    
} */

.settings_settingsMainContainer__vDKK6 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 10px;
  width: 100%;
}
@media screen and (min-width: 768px) {
  .settings_settingsMainContainer__vDKK6 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}
@media screen and (min-width: 1024px) {
  .settings_settingsMainContainer__vDKK6 {
    justify-content: flex-start;
    padding: 20px 50px;
  }
}
.settings_settingPageNotificationContainer__uL6nl {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 9000;
  position: absolute;
}
@media screen and (min-width: 768px) {
  .settings_settingPageNotificationContainer__uL6nl {
    margin-left: calc(60% - (20% / 2));
  }
}
@media screen and (min-width: 1024px) {
  .settings_settingPageNotificationContainer__uL6nl {
    margin-left: calc(68% - (20% / 2));
    width: 380px;
  }
}
@media screen and (min-width: 1260px) {
  .settings_settingPageNotificationContainer__uL6nl {
    margin-left: calc(76% - (20% / 2));
  }
}
@media screen and (min-width: 1440px) {
  .settings_settingPageNotificationContainer__uL6nl {
    margin-left: calc(80% - (20% / 2));
  }
}
.settings_emailnotify__-v7oZ > p {
  font-size: 1rem;
  margin-left: 27px;
}

p {
}
.settings_sidebarParentoptions__wJBWr {
  background-color: white !important;
  border-radius: 25px !important;
  height: -moz-fit-content;
  height: fit-content;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.settings_sidebarParentoptionsdarkTheme__jE5qy {
  background-color: #585858 !important;
  color: whitesmoke;
}
.settings_sidebarParentoptions1__UCl5R {
  margin-inline-start: 15px;
  margin-block-start: 10px;
  padding-bottom: 3%;
  margin-inline-end: 30px;
  /* flex:auto; */
}

.settings_settingoptions__dQwXG {
  display: flex;
  flex: auto;
}

.settings_settingPagePermitionsMainContainer__qCVEU {
  width: 100vw;
  margin: auto;
  margin-top: 20px;
  margin-left: -23px;
  position: relative; /* Added position: relative */
}

@media screen and (min-width: 768px) {
  .settings_settingPagePermitionsMainContainer__qCVEU {
    width: 50%;
  }
}

.settings_sidebarchildoptions__zmV9r {
  margin-left: 1.7rem;
  border-radius: 25px;
  background-color: #ffffff;
  /* max-width: 100%; */
  margin-bottom: 3%;
  flex: auto;
  /* box-shadow:1px 2px 3px #4795DE; */
}
.settings_sidebarChildContentOptions__W9Qlz {
  border-radius: 25px;
  background-color: #ffffff;
  width: 100%;
  margin-bottom: 3%;
  /* box-shadow:1px 2px 3px #4795DE; */
}
@media screen and (min-width: 768px) {
  .settings_sidebarChildContentOptions__W9Qlz {
    margin-left: 1.7rem;
    border-radius: 25px;
    background-color:  #ffffff;
    width: 50vw;
    margin-bottom: 3%;
    flex: auto;
    /* box-shadow:1px 2px 3px #4795DE; */
  }
}
.settings_sidebarchildoptionsdarkTheme__\\+Ozz3 {
  background-color: #585858;
  color: whitesmoke;
}

.settings_divider__rGA9V {
  margin-left: 7% !important;
  margin-right: 70% !important;
  margin-bottom: 2% !important;
}
.settings_emailnotify__-v7oZ {
  display: flex;
  align-items: center;
  padding-left: 26px;
}
.settings_emailicon__C8aTf {
  display: flex;
  position: relative;
  padding-top: 6px;
  right: 10px;
  left: 18px;
}
.settings_emailnotification__bCzZ4 {
  /* position: absolute; */
  width: 20px;
  height: 20px;
  /* left: 6px; */
  /* bottom: 27px; */
}

.settings_sidebarchildoptionsheader__ZQeTc {
  margin-top: 20px;
}
.settings_sidebarchildoptionsheader1__mxVdz {
  margin-top: 13px;
}
.settings_sidebarchildoptionsheader2__mWvCR {
  margin-top: 13px;
}
.settings_sidebarchildoptionsocialmediapswdchange__OV12M {
  display: flex;
  padding-top: 15px;
}

@media all and (max-width: 458px) {
  html {
    width: -moz-fit-content !important;
    width: fit-content !important;
  }
  .settings_emailnotify__-v7oZ {
    padding-left: 10px;
  }
  .settings_emailicon__C8aTf {
    padding-top: 8px;
  }
  .settings_emailnotification__bCzZ4 {
    top: 26px !important;
  }
  .settings_emailnotificationsoptions__uOPIe {
    padding-bottom: 4px;
  }
  .settings_sidebartoggleoptions__2wmkd {
    margin-right: 5%;
    margin-left: 6%;
  }
  .settings_settingoptions__dQwXG {
    flex-flow: column nowrap;
  }
  .settings_sidebarParentoptions__wJBWr {
    margin-right: 41px;
  }
}

@media screen and (min-width: 768px) {
  .settings_sidebarParentoptions__wJBWr {
    margin-right: 18px;
    margin-top: 18px;
    width: 280px;
  }
}
@media screen and (min-width: 1024px) {
  .settings_sidebarParentoptions__wJBWr {
    margin-right: 18px;
    margin-top: 18px;
  }
}

.settings_focusapperance__k9gQy {
  /* box-shadow: 2px 4px 4px 2px #4795de; */
}
.settings_sidebarchildoptions__zmV9r > h2 {
  display: flex;
}

/* .h2{
    padding-top: 3% !important;
    padding-left: 1% !important;
    font-size: large !important;
} */

.settings_resetpassword__SK91D {
  justify-content: space-between;
  display: flex;
  margin-left: 3%;
  margin-right: 30%;
  margin-top: 1%;
  margin-bottom: 3%;
}

.settings_sidebartoggleoptions__2wmkd {
  flex: auto;
  margin-top: 5%;
  margin-right: 10%;
}

.settings_emailnotificationsoptions__uOPIe > input[type="checkbox"] {
  height: 0;
  width: 0;
  visibility: hidden;
}

.settings_inputlabel__9KEqt {
  cursor: pointer;
  text-indent: -9999px;
  width: 30px;
  height: 17px;
  background: grey;
  display: block;
  border-radius: 100px;
  position: relative;
}

.settings_inputlabel__9KEqt:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  width: 15px;
  height: 15px;
  background: #fff;
  border-radius: 90px;
  transition: 0.3s;
}

input:checked + .settings_inputlabel__9KEqt {
  background: #4795de;
}

input:checked + .settings_inputlabel__9KEqt:after {
  left: calc(100% - 1px);
  transform: translateX(-100%);
}

.settings_inputlabel__9KEqt:active:after {
  width: 13px;
}

.settings_lastoption__toFpu {
  padding-bottom: 3%;
}

.settings_socialmedia__Tc5sP {
  max-width: 17px;
  max-height: 17px;
  margin-top: 16px;
  margin-right: 12px;
  margin-left: 45px;
}
.settings_password__qABvE {
  max-width: 15px;
  max-height: 18px;
  margin-top: 16px;
  margin-right: 12px;
  margin-left: 45px;
}

/* // centering */
/* body {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
} */
.settings_emailnotificationsoptions__uOPIe {
  display: flex;
  justify-content: space-between;
  margin-left: 7%;
  margin-right: 7%;
}

.settings_inputpassword__XwiWy {
  outline: 0;
}

.settings_signoutbutton__EvPTb {
  text-align: center;
}

.settings_signout__H73hO {
  font-size: 1.1rem !important;
  width: 100% !important;
  border-radius: 25px !important;
  color: #373334 !important;
  outline: none !important;
}

.settings_submit__PR7AH {
  margin-left: 45% !important ;
  background: #6ca8e1 !important;
  border-radius: 25px !important;
  min-width: 88px !important;
  text-emphasis-color: white;
  color: white !important;
  text-transform: none !important;
  margin-bottom: 3% !important;
  outline: none !important;
}

.settings_submitdarkTheme__ngcS5 {
  color: whitesmoke !important;
}
.settings_buttontextdarkTheme__XYx38 {
  filter: invert(100%);
}

.settings_inputpassword__XwiWy {
  position: absolute !important;
}
.settings_passwordimg__sWhgi {
  margin-left: 150px !important;
}

.settings_passwordlabel__4XXBh {
  padding-top: 2%;
  padding-left: 5.2%;
}

.settings_notifications__ctYkx {
  display: flex;
  padding: 10px 0px 10px 15px;
  border-radius: 25px;
  background-color: #ffffff;
  position: absolute;
  right: 1%;
  box-shadow: 0px 3px 6px #00000029;
  z-index: 555;
}
@media screen and (min-width: 1024px) {
  .settings_notifications__ctYkx {
    width: 350px;
  }
}
.settings_notificationscroll__DPxfL {
  padding-right: 7px;
  overflow-y: scroll;
  height: 818px;
  scrollbar-width: thin;
  scrollbar-color: #6b71c9;
  width: -moz-available;
}
.settings_notificationscroll__DPxfL::-webkit-scrollbar {
  width: 4px;
}
.settings_notificationscroll__DPxfL::-webkit-scrollbar-thumb {
  background: #707070;
  border-radius: 10px;
}
.settings_notificationscroll__DPxfL::-webkit-scrollbar-thumb:hover {
  background: #6b71c9;
}

.settings_message__I3980 {
  padding: 0;
  text-align: center;
  font-size: 12px;
  color: red;
}
.settings_message__I3980:last-child {
  padding: 0;
  text-align: center;
  font-size: 12px;
  color: green;
}

.settings_eyeshowhide__1yh3Y {
  font-size: 1rem !important;
}

/* .sidebarchildoptions: */

.settings_help__4XXq2 {
  padding: 25px;
}

/*Terms and Service*/

.settings_TermsofService__VRwZQ {
  margin: 0 auto;
  background: #ffffff;
  padding: 25px;
  border-radius: 25px;
}
.settings_privacyheading__ZzG6j {
  width: -moz-fit-content;
  width: fit-content;
  /* left: 10%;
position: absolute;
top: 20%; */
}

.settings_careersMail__ngkdE {
  margin: 0 0 10px 1.7rem;
}

.settings_author__q8nmb {
  margin: 1% 0 2% 0;
  /* position: absolute;
    top: 70%; */
}

/*about*/
.settings_aboutImages__WuT9A {
  display: flex;
  justify-content: space-evenly;
}
.settings_aboutText__vC0i3 {
  text-align: center;
  margin-top: 4%;
  margin-bottom: 0;
}

.settings_profileCommunityAndActivityMainContainer__cEXlN {
  background-color: #F3F2F0;
  padding-top: 25px;
}
.settings_communityAndActivityMainContainer__8L4LD {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  gap: 20px;
}

@media screen and (min-width: 768px) {
  .settings_communityAndActivityMainContainer__8L4LD {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
    max-width: 1090px;
    margin: 0 auto;
    /* background-color: chartreuse; */
  }
}
.settings_headerContainer__35sgn{
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding: 12px 30px;
}
.settings_footerMainContainer__PhNUn{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/settings/settings.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,kCAAkC;IAClC,YAAY;EACd;AACF;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;AACA;AACA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAmB;EAAnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,oCAAoC;EACtC;AACF;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,kCAA6B;IAA7B,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;;AAEA;;;;GAIG;;AAEH;EACE,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;;;;GAKG;AACH;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,iCAAiC;EACjC,YAAY;AACd;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;AACf;;AAEA,oBAAoB;;AAEpB;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB;;WAES;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB;eACa;AACf;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kCAAkC;EACpC;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".body {\r\n  background-color: #F3F2F0;\r\n  margin: 0;\r\n  /* padding: 0; */\r\n}\r\n\r\n.darkthemebody {\r\n  background-color: #363537;\r\n}\r\n\r\n/* *{\r\n    margin: 0 !important;\r\n    \r\n} */\r\n\r\n.settingsMainContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 10px 10px;\r\n  width: 100%;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .settingsMainContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .settingsMainContainer {\r\n    justify-content: flex-start;\r\n    padding: 20px 50px;\r\n  }\r\n}\r\n.settingPageNotificationContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  z-index: 9000;\r\n  position: absolute;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .settingPageNotificationContainer {\r\n    margin-left: calc(60% - (20% / 2));\r\n  }\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .settingPageNotificationContainer {\r\n    margin-left: calc(68% - (20% / 2));\r\n    width: 380px;\r\n  }\r\n}\r\n@media screen and (min-width: 1260px) {\r\n  .settingPageNotificationContainer {\r\n    margin-left: calc(76% - (20% / 2));\r\n  }\r\n}\r\n@media screen and (min-width: 1440px) {\r\n  .settingPageNotificationContainer {\r\n    margin-left: calc(80% - (20% / 2));\r\n  }\r\n}\r\n.emailnotify > p {\r\n  font-size: 1rem;\r\n  margin-left: 27px;\r\n}\r\n\r\np {\r\n}\r\n.sidebarParentoptions {\r\n  background-color: white !important;\r\n  border-radius: 25px !important;\r\n  height: fit-content;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 100%;\r\n}\r\n\r\n.sidebarParentoptionsdarkTheme {\r\n  background-color: #585858 !important;\r\n  color: whitesmoke;\r\n}\r\n.sidebarParentoptions1 {\r\n  margin-inline-start: 15px;\r\n  margin-block-start: 10px;\r\n  padding-bottom: 3%;\r\n  margin-inline-end: 30px;\r\n  /* flex:auto; */\r\n}\r\n\r\n.settingoptions {\r\n  display: flex;\r\n  flex: auto;\r\n}\r\n\r\n.settingPagePermitionsMainContainer {\r\n  width: 100vw;\r\n  margin: auto;\r\n  margin-top: 20px;\r\n  margin-left: -23px;\r\n  position: relative; /* Added position: relative */\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .settingPagePermitionsMainContainer {\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n.sidebarchildoptions {\r\n  margin-left: 1.7rem;\r\n  border-radius: 25px;\r\n  background-color: #ffffff;\r\n  /* max-width: 100%; */\r\n  margin-bottom: 3%;\r\n  flex: auto;\r\n  /* box-shadow:1px 2px 3px #4795DE; */\r\n}\r\n.sidebarChildContentOptions {\r\n  border-radius: 25px;\r\n  background-color: #ffffff;\r\n  width: 100%;\r\n  margin-bottom: 3%;\r\n  /* box-shadow:1px 2px 3px #4795DE; */\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .sidebarChildContentOptions {\r\n    margin-left: 1.7rem;\r\n    border-radius: 25px;\r\n    background-color:  #ffffff;\r\n    width: 50vw;\r\n    margin-bottom: 3%;\r\n    flex: auto;\r\n    /* box-shadow:1px 2px 3px #4795DE; */\r\n  }\r\n}\r\n.sidebarchildoptionsdarkTheme {\r\n  background-color: #585858;\r\n  color: whitesmoke;\r\n}\r\n\r\n.divider {\r\n  margin-left: 7% !important;\r\n  margin-right: 70% !important;\r\n  margin-bottom: 2% !important;\r\n}\r\n.emailnotify {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 26px;\r\n}\r\n.emailicon {\r\n  display: flex;\r\n  position: relative;\r\n  padding-top: 6px;\r\n  right: 10px;\r\n  left: 18px;\r\n}\r\n.emailnotification {\r\n  /* position: absolute; */\r\n  width: 20px;\r\n  height: 20px;\r\n  /* left: 6px; */\r\n  /* bottom: 27px; */\r\n}\r\n\r\n.sidebarchildoptionsheader {\r\n  margin-top: 20px;\r\n}\r\n.sidebarchildoptionsheader1 {\r\n  margin-top: 13px;\r\n}\r\n.sidebarchildoptionsheader2 {\r\n  margin-top: 13px;\r\n}\r\n.sidebarchildoptionsocialmediapswdchange {\r\n  display: flex;\r\n  padding-top: 15px;\r\n}\r\n\r\n@media all and (max-width: 458px) {\r\n  html {\r\n    width: fit-content !important;\r\n  }\r\n  .emailnotify {\r\n    padding-left: 10px;\r\n  }\r\n  .emailicon {\r\n    padding-top: 8px;\r\n  }\r\n  .emailnotification {\r\n    top: 26px !important;\r\n  }\r\n  .emailnotificationsoptions {\r\n    padding-bottom: 4px;\r\n  }\r\n  .sidebartoggleoptions {\r\n    margin-right: 5%;\r\n    margin-left: 6%;\r\n  }\r\n  .settingoptions {\r\n    flex-flow: column nowrap;\r\n  }\r\n  .sidebarParentoptions {\r\n    margin-right: 41px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .sidebarParentoptions {\r\n    margin-right: 18px;\r\n    margin-top: 18px;\r\n    width: 280px;\r\n  }\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .sidebarParentoptions {\r\n    margin-right: 18px;\r\n    margin-top: 18px;\r\n  }\r\n}\r\n\r\n.focusapperance {\r\n  /* box-shadow: 2px 4px 4px 2px #4795de; */\r\n}\r\n.sidebarchildoptions > h2 {\r\n  display: flex;\r\n}\r\n\r\n/* .h2{\r\n    padding-top: 3% !important;\r\n    padding-left: 1% !important;\r\n    font-size: large !important;\r\n} */\r\n\r\n.resetpassword {\r\n  justify-content: space-between;\r\n  display: flex;\r\n  margin-left: 3%;\r\n  margin-right: 30%;\r\n  margin-top: 1%;\r\n  margin-bottom: 3%;\r\n}\r\n\r\n.sidebartoggleoptions {\r\n  flex: auto;\r\n  margin-top: 5%;\r\n  margin-right: 10%;\r\n}\r\n\r\n.emailnotificationsoptions > input[type=\"checkbox\"] {\r\n  height: 0;\r\n  width: 0;\r\n  visibility: hidden;\r\n}\r\n\r\n.inputlabel {\r\n  cursor: pointer;\r\n  text-indent: -9999px;\r\n  width: 30px;\r\n  height: 17px;\r\n  background: grey;\r\n  display: block;\r\n  border-radius: 100px;\r\n  position: relative;\r\n}\r\n\r\n.inputlabel:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 1px;\r\n  left: 1px;\r\n  width: 15px;\r\n  height: 15px;\r\n  background: #fff;\r\n  border-radius: 90px;\r\n  transition: 0.3s;\r\n}\r\n\r\ninput:checked + .inputlabel {\r\n  background: #4795de;\r\n}\r\n\r\ninput:checked + .inputlabel:after {\r\n  left: calc(100% - 1px);\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.inputlabel:active:after {\r\n  width: 13px;\r\n}\r\n\r\n.lastoption {\r\n  padding-bottom: 3%;\r\n}\r\n\r\n.socialmedia {\r\n  max-width: 17px;\r\n  max-height: 17px;\r\n  margin-top: 16px;\r\n  margin-right: 12px;\r\n  margin-left: 45px;\r\n}\r\n.password {\r\n  max-width: 15px;\r\n  max-height: 18px;\r\n  margin-top: 16px;\r\n  margin-right: 12px;\r\n  margin-left: 45px;\r\n}\r\n\r\n/* // centering */\r\n/* body {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\theight: 100vh;\r\n} */\r\n.emailnotificationsoptions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-left: 7%;\r\n  margin-right: 7%;\r\n}\r\n\r\n.inputpassword {\r\n  outline: 0;\r\n}\r\n\r\n.signoutbutton {\r\n  text-align: center;\r\n}\r\n\r\n.signout {\r\n  font-size: 1.1rem !important;\r\n  width: 100% !important;\r\n  border-radius: 25px !important;\r\n  color: #373334 !important;\r\n  outline: none !important;\r\n}\r\n\r\n.submit {\r\n  margin-left: 45% !important ;\r\n  background: #6ca8e1 !important;\r\n  border-radius: 25px !important;\r\n  min-width: 88px !important;\r\n  text-emphasis-color: white;\r\n  color: white !important;\r\n  text-transform: none !important;\r\n  margin-bottom: 3% !important;\r\n  outline: none !important;\r\n}\r\n\r\n.submitdarkTheme {\r\n  color: whitesmoke !important;\r\n}\r\n.buttontextdarkTheme {\r\n  filter: invert(100%);\r\n}\r\n\r\n.inputpassword {\r\n  position: absolute !important;\r\n}\r\n.passwordimg {\r\n  margin-left: 150px !important;\r\n}\r\n\r\n.passwordlabel {\r\n  padding-top: 2%;\r\n  padding-left: 5.2%;\r\n}\r\n\r\n.notifications {\r\n  display: flex;\r\n  padding: 10px 0px 10px 15px;\r\n  border-radius: 25px;\r\n  background-color: #ffffff;\r\n  position: absolute;\r\n  right: 1%;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  z-index: 555;\r\n}\r\n@media screen and (min-width: 1024px) {\r\n  .notifications {\r\n    width: 350px;\r\n  }\r\n}\r\n.notificationscroll {\r\n  padding-right: 7px;\r\n  overflow-y: scroll;\r\n  height: 818px;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #6b71c9;\r\n  width: -moz-available;\r\n}\r\n.notificationscroll::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n.notificationscroll::-webkit-scrollbar-thumb {\r\n  background: #707070;\r\n  border-radius: 10px;\r\n}\r\n.notificationscroll::-webkit-scrollbar-thumb:hover {\r\n  background: #6b71c9;\r\n}\r\n\r\n.message {\r\n  padding: 0;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  color: red;\r\n}\r\n.message:last-child {\r\n  padding: 0;\r\n  text-align: center;\r\n  font-size: 12px;\r\n  color: green;\r\n}\r\n\r\n.eyeshowhide {\r\n  font-size: 1rem !important;\r\n}\r\n\r\n/* .sidebarchildoptions: */\r\n\r\n.help {\r\n  padding: 25px;\r\n}\r\n\r\n/*Terms and Service*/\r\n\r\n.TermsofService {\r\n  margin: 0 auto;\r\n  background: #ffffff;\r\n  padding: 25px;\r\n  border-radius: 25px;\r\n}\r\n.privacyheading {\r\n  width: fit-content;\r\n  /* left: 10%;\r\nposition: absolute;\r\ntop: 20%; */\r\n}\r\n\r\n.careersMail {\r\n  margin: 0 0 10px 1.7rem;\r\n}\r\n\r\n.author {\r\n  margin: 1% 0 2% 0;\r\n  /* position: absolute;\r\n    top: 70%; */\r\n}\r\n\r\n/*about*/\r\n.aboutImages {\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n}\r\n.aboutText {\r\n  text-align: center;\r\n  margin-top: 4%;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.profileCommunityAndActivityMainContainer {\r\n  background-color: #F3F2F0;\r\n  padding-top: 25px;\r\n}\r\n.communityAndActivityMainContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 20px;\r\n  gap: 20px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .communityAndActivityMainContainer {\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    gap: 20px;\r\n    width: 100%;\r\n    max-width: 1090px;\r\n    margin: 0 auto;\r\n    /* background-color: chartreuse; */\r\n  }\r\n}\r\n.headerContainer{\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: transparent;\r\n  padding: 12px 30px;\r\n}\r\n.footerMainContainer{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `settings_body__gT4Kj`,
	"darkthemebody": `settings_darkthemebody__YlAZc`,
	"settingsMainContainer": `settings_settingsMainContainer__vDKK6`,
	"settingPageNotificationContainer": `settings_settingPageNotificationContainer__uL6nl`,
	"emailnotify": `settings_emailnotify__-v7oZ`,
	"sidebarParentoptions": `settings_sidebarParentoptions__wJBWr`,
	"sidebarParentoptionsdarkTheme": `settings_sidebarParentoptionsdarkTheme__jE5qy`,
	"sidebarParentoptions1": `settings_sidebarParentoptions1__UCl5R`,
	"settingoptions": `settings_settingoptions__dQwXG`,
	"settingPagePermitionsMainContainer": `settings_settingPagePermitionsMainContainer__qCVEU`,
	"sidebarchildoptions": `settings_sidebarchildoptions__zmV9r`,
	"sidebarChildContentOptions": `settings_sidebarChildContentOptions__W9Qlz`,
	"sidebarchildoptionsdarkTheme": `settings_sidebarchildoptionsdarkTheme__+Ozz3`,
	"divider": `settings_divider__rGA9V`,
	"emailicon": `settings_emailicon__C8aTf`,
	"emailnotification": `settings_emailnotification__bCzZ4`,
	"sidebarchildoptionsheader": `settings_sidebarchildoptionsheader__ZQeTc`,
	"sidebarchildoptionsheader1": `settings_sidebarchildoptionsheader1__mxVdz`,
	"sidebarchildoptionsheader2": `settings_sidebarchildoptionsheader2__mWvCR`,
	"sidebarchildoptionsocialmediapswdchange": `settings_sidebarchildoptionsocialmediapswdchange__OV12M`,
	"emailnotificationsoptions": `settings_emailnotificationsoptions__uOPIe`,
	"sidebartoggleoptions": `settings_sidebartoggleoptions__2wmkd`,
	"focusapperance": `settings_focusapperance__k9gQy`,
	"resetpassword": `settings_resetpassword__SK91D`,
	"inputlabel": `settings_inputlabel__9KEqt`,
	"lastoption": `settings_lastoption__toFpu`,
	"socialmedia": `settings_socialmedia__Tc5sP`,
	"password": `settings_password__qABvE`,
	"inputpassword": `settings_inputpassword__XwiWy`,
	"signoutbutton": `settings_signoutbutton__EvPTb`,
	"signout": `settings_signout__H73hO`,
	"submit": `settings_submit__PR7AH`,
	"submitdarkTheme": `settings_submitdarkTheme__ngcS5`,
	"buttontextdarkTheme": `settings_buttontextdarkTheme__XYx38`,
	"passwordimg": `settings_passwordimg__sWhgi`,
	"passwordlabel": `settings_passwordlabel__4XXBh`,
	"notifications": `settings_notifications__ctYkx`,
	"notificationscroll": `settings_notificationscroll__DPxfL`,
	"message": `settings_message__I3980`,
	"eyeshowhide": `settings_eyeshowhide__1yh3Y`,
	"help": `settings_help__4XXq2`,
	"TermsofService": `settings_TermsofService__VRwZQ`,
	"privacyheading": `settings_privacyheading__ZzG6j`,
	"careersMail": `settings_careersMail__ngkdE`,
	"author": `settings_author__q8nmb`,
	"aboutImages": `settings_aboutImages__WuT9A`,
	"aboutText": `settings_aboutText__vC0i3`,
	"profileCommunityAndActivityMainContainer": `settings_profileCommunityAndActivityMainContainer__cEXlN`,
	"communityAndActivityMainContainer": `settings_communityAndActivityMainContainer__8L4LD`,
	"headerContainer": `settings_headerContainer__35sgn`,
	"footerMainContainer": `settings_footerMainContainer__PhNUn`
};
export default ___CSS_LOADER_EXPORT___;
